// eslint-disable-next-line jira/filename-case
import { useCallback } from 'react';
import { useOverflowStatus } from '@atlaskit/atlassian-navigation/overflow';
import {
	useAnalyticsEvents,
	fireUIAnalytics,
	type Attributes as AnalyticsAttributes,
} from '@atlassian/jira-product-analytics-bridge';
import type { UseUniversalCreateAnalyticsType } from '../types.tsx';

export const useUniversalCreateAnalytics: UseUniversalCreateAnalyticsType = () => {
	const { isVisible } = useOverflowStatus();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useCallback(
		(attributes = {}) => {
			const analyticsEvent = createAnalyticsEvent({
				action: 'clicked',
				actionSubject: 'navigationItem',
			});

			// oxlint-disable-next-line typescript/consistent-type-assertions
			fireUIAnalytics(analyticsEvent, 'universal-create-trigger-button', {
				// @ts-expect-error - TS2698 - Spread types may only be created from object types.
				...attributes,
				isInMore: !isVisible,
				navigationLayer: 'global',
			} as AnalyticsAttributes);
		},
		[createAnalyticsEvent, isVisible],
	);
};
